import { reactive, toRefs } from "vue";
import type { Ref } from "vue";
import { os2 } from "@/utils/env";
import { useStorage } from "@vueuse/core";
import { TOKEN } from "@/pages/website/const";

export const gamerToken = useStorage(TOKEN, "");
const globalData = reactive<{
  gameId: string;
  videoUrl: string;
  isShowVideo: boolean;
  isShowSubscribePop: boolean;
  isShowSubscribeSuccessPop: boolean;
  isPc: boolean;
  config: IConfig;
  newsTabsList: INewsTab[];
  curNewsTab: number;
  isPlayBgm: boolean;
  eventConfigData: IEventConfig;
  currentActivity: IFeature | null;
  isSubscribed: boolean;
  ssoToken: string;
  userInfo: IUserProfileData;
  isWapShowMediaPop: boolean;
  isInitVisit: boolean;
  isShowDownloadButton: boolean;
  isDownloadShowWxPop: boolean;
  currentMenuIndex: number;
  showGiftBag: boolean;
  guideCategoryList: INewsTab[];
  guideTabIndex: number;
}>({
  gameId: "",
  videoUrl: "",
  isShowVideo: false,
  isShowSubscribePop: false,
  isShowSubscribeSuccessPop: false,
  isPc: os2 === "pc",
  config: {
    pcBgUrl: "",
    mBgUrl: "",
    created: 0,
    pc_slogan: "",
    m_slogan: "",
    pcVideoUrl: "",
    mTsVideoUrl: "",
    mVideoUrl: "",
    mVideoGif: "",
    topVideoUrl: "",
    pics: [],
    activityImg: "",
    activityUrl: "",
    socialMedia: {
      qq: "",
      qqQr: "",
      douyin: "",
      douyinQr: "",
      weixin: "",
      downloadQr: "",
      weibo: "",
      weiboQr: "",
      xiaohongshu: "",
      xiaohongshuQr: "",
      weixinDesc: "",
      weixinxiaochengxu: "",
      weixinxiaochengxuDesc: "",
      bilibili: "",
      bilibiliQr: "",
      qqkj: "",
      downloadOpenDate: [0, 0],
    },
    music: "",
    logoPc: "",
    logoM: "",
    gameDesc: "",
    gameDescLine2: "",
    videoPoster: "",
    service: "",
    serviceDesc: "",
    serviceUrl: "",
    milestone: {
      list: [],
    },
    recordNew: {
      list: [],
    },
    subscribePrize: {
      list: [],
    },
    gameViewNew: {
      list: [],
    },
    gameFeature: {
      list: [],
    },
    ageUrl: "",
    fszl: {
      list: [],
    },
    iconM: "",
    videoButtonTop: "0",
    videoButtonLeft: "0",
    videoButtonBottomM: "0",
    videoButtonLeftM: "0",
    videoButtonBottomMSmall: "0",
    videoButtonLeftMSmall: "0",
    guide: [],
    recommendingOfficer: [],
  },
  newsTabsList: [],
  curNewsTab: 0,
  isPlayBgm: false,
  eventConfigData: {
    event_name: "",
    features: [],
  },
  currentActivity: null,
  isSubscribed: false,
  ssoToken: "",
  userInfo: {
    user_id: "",
    mobile: "",
  },
  isWapShowMediaPop: false,
  isInitVisit: false,
  isShowDownloadButton: false,
  isDownloadShowWxPop: false,
  currentMenuIndex: 0,
  showGiftBag: false,
  guideCategoryList: [],
  guideTabIndex: 0,
});

export const useGlobalData = function (): {
  gameId: Ref<string>;
  videoUrl: Ref<string>;
  isShowVideo: Ref<boolean>;
  isShowSubscribePop: Ref<boolean>;
  isShowSubscribeSuccessPop: Ref<boolean>;
  isPc: Ref<boolean>;
  config: Ref<IConfig>;
  newsTabsList: Ref<INewsTab[]>;
  curNewsTab: Ref<number>;
  isPlayBgm: Ref<boolean>;
  eventConfigData: Ref<IEventConfig>;
  currentActivity: Ref<IFeature | null>;
  isSubscribed: Ref<boolean>;
  ssoToken: Ref<string>;
  userInfo: Ref<IUserProfileData>;
  isWapShowMediaPop: Ref<boolean>;
  isInitVisit: Ref<boolean>;
  isShowDownloadButton: Ref<boolean>;
  isDownloadShowWxPop: Ref<boolean>;
  currentMenuIndex: Ref<number>;
  showGiftBag: Ref<boolean>;
  guideCategoryList: Ref<INewsTab[]>;
  guideTabIndex: Ref<number>;
} {
  return toRefs(globalData);
};
